/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as ioTs from "io-ts";

export const LocalizedPolicy = ioTs.intersection([
  ioTs.type({
    id: ioTs.string,
    localeCode: ioTs.string,
    isDefaultSelection: ioTs.boolean,
  }),
  ioTs.partial({
    contentType: ioTs.string,
    attachmentChecksum: ioTs.string,
    attachmentLocation: ioTs.string,
    attachmentVersionIdentifier: ioTs.string,
    createdAt: ioTs.string,
    updatedAt: ioTs.string,
    description: ioTs.string,
  }),
]);
export type LocalizedPolicy = ioTs.TypeOf<typeof LocalizedPolicy>;

export const PolicyVersion = ioTs.intersection([
  ioTs.type({
    id: ioTs.string,
    displayVersion: ioTs.string,
    isCommitted: ioTs.boolean,
    isInEffect: ioTs.boolean,
  }),
  ioTs.partial({
    publishedDate: ioTs.string,
    createdAt: ioTs.string,
    updatedAt: ioTs.string,
    description: ioTs.string,
    localizedPolicyVersions: ioTs.array(LocalizedPolicy),
  }),
]);
export type PolicyVersion = ioTs.TypeOf<typeof PolicyVersion>;

export const Policy = ioTs.intersection([
  ioTs.type({
    id: ioTs.string,
    policyName: ioTs.string,
    countryCode: ioTs.string,
    shouldNotifyOnUpdate: ioTs.boolean,
    isMandatory: ioTs.boolean,
    isDefaultOpted: ioTs.boolean,
  }),
  ioTs.partial({
    createdAt: ioTs.string,
    updatedAt: ioTs.string,
    readableId: ioTs.string,
    namespace: ioTs.string,
    baseUrls: ioTs.array(ioTs.string),
    countryGroupCode: ioTs.string,
    policyVersions: ioTs.array(PolicyVersion),
    description: ioTs.string,
  }),
]);
export type Policy = ioTs.TypeOf<typeof Policy>;

export const PolicyList = ioTs.array(Policy);
export type PolicyList = ioTs.TypeOf<typeof PolicyList>;

export const LocalizedPolicyInformation = ioTs.intersection([
  ioTs.type({
    id: ioTs.string,
    localeCode: ioTs.string,
    namespace: ioTs.string,
  }),
  ioTs.partial({
    baseUrls: ioTs.array(ioTs.string),
    attachmentLocation: ioTs.string,
    attachmentChecksum: ioTs.string,
    createdAt: ioTs.string,
    updatedAt: ioTs.string,
    contentType: ioTs.string,
    attachmentVersionIdentifier: ioTs.string,
    description: ioTs.string,
    policyVersion: PolicyVersion,
    policy: Policy,
  }),
]);
export type LocalizedPolicyInformation = ioTs.TypeOf<typeof LocalizedPolicyInformation>;
